var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 0C5.93029 0 5.33333 0.671573 5.33333 1.5C5.33333 2.32843 5.93029 3 6.66667 3H9.33333C10.0697 3 10.6667 2.32843 10.6667 1.5C10.6667 0.671573 10.0697 0 9.33333 0H6.66667Z",
    fill: "#7F3DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.5C0 2.84315 1.19391 1.5 2.66667 1.5C2.66667 3.98528 4.45753 6 6.66667 6H9.33333C11.5425 6 13.3333 3.98528 13.3333 1.5C14.8061 1.5 16 2.84315 16 4.5V21C16 22.6569 14.8061 24 13.3333 24H2.66667C1.19391 24 0 22.6569 0 21V4.5ZM12.9428 13.0607C13.4635 12.4749 13.4635 11.5251 12.9428 10.9393C12.4221 10.3536 11.5779 10.3536 11.0572 10.9393L6.66667 15.8787L4.94281 13.9393C4.42211 13.3536 3.57789 13.3536 3.05719 13.9393C2.53649 14.5251 2.53649 15.4749 3.05719 16.0607L5.72386 19.0607C6.24456 19.6464 7.08878 19.6464 7.60948 19.0607L12.9428 13.0607Z",
    fill: "#7F3DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/Task.f17cf48f.svg";
export { ForwardRef as ReactComponent };